// ** React Imports
import { memo, useState, useRef, useEffect } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Components
import Block from "components/layout/Block";
import ShowMoreButton from "components/layout/ShowMoreButton";

// ** Styled Components
import styled from "styled-components";

// #####################################################

const StyledTextContainer = styled.div`
	display: -webkit-box;
	-webkit-line-clamp: ${({ expanded, maxLines }) =>
		expanded ? "unset" : maxLines};
	-webkit-box-orient: vertical;
	overflow: hidden;
	color: ${({ color }) => color || "inherit"};
	word-break: break-word;
`;

// #####################################################

const MultiLineText = ({
	text,
	maxLines = 2, // domyślnie 2 linie
	withShowMoreButton = true,
	showMoreButtonAlwaysVisible = false,
	color,
	allowDangerousHtml,
}) => {
	const { t } = useTranslation(["common", "pages"]);
	const [isOverflowing, setIsOverflowing] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const textRef = useRef(null);

	useEffect(() => {
		const checkOverflow = () => {
			if (textRef.current) {
				const lineHeight = parseInt(
					window.getComputedStyle(textRef.current).lineHeight
				);
				const isOverflow =
					textRef.current.scrollHeight > lineHeight * maxLines;
				setIsOverflowing(isOverflow);
			}
		};

		checkOverflow();
		window.addEventListener("resize", checkOverflow);
		return () => window.removeEventListener("resize", checkOverflow);
	}, [text, maxLines]); // dodałem maxLines do zależności

	return (
		<Block>
			<StyledTextContainer
				ref={textRef}
				expanded={expanded}
				color={color}
				maxLines={maxLines}
			>
				{allowDangerousHtml ? (
					<div dangerouslySetInnerHTML={{ __html: text }} />
				) : (
					text
				)}
			</StyledTextContainer>
			{withShowMoreButton && (
				<Block flex justifyEnd>
					{((isOverflowing && !expanded) ||
						(showMoreButtonAlwaysVisible && !expanded)) && (
						<ShowMoreButton onClick={() => setExpanded(true)}>
							{t("common:showMore")}
						</ShowMoreButton>
					)}
					{expanded && (
						<ShowMoreButton onClick={() => setExpanded(false)}>
							{t("common:showLess")}
						</ShowMoreButton>
					)}
				</Block>
			)}
		</Block>
	);
};

// #####################################################

export default memo(MultiLineText);

// #####################################################
